import styled from 'styled-components'

import StatisticGroup from '@/common/components/StatisticGroup/StatisticGroup'

export const InsightsRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  height: 100%;
`

export const TransactionsStatsContainer = styled.div`
  display: flex;
  flex: 1;
  gap: ${props => props.theme.spacing.sp8};
`

export const StatContainer = styled.div`
  display: flex;
  flex: 1;
`

export const EarningsGroup = styled(StatisticGroup)`
  flex: 1;
`
